






























import { Component, Vue } from "@zoovu/runner-browser-api";
import { ProductPriceView } from "@zoovu/runner-web-design-base";

@Component({
  name: "ProductPriceView",
  mixins: [ProductPriceView],
})
export default class ProductPriceViewExtended extends Vue {
  get assistantLocale(): string {
    return this.localizationSettings.locale;
  }
  get priceToFormat(): string {
    return (
      this.recommendation?.price?.rawValue?.valueTranslation?.replace(
        "$",
        "USD "
      ) || " "
    );
  }
  get customPriceFormat(): string {
    if (this.assistantLocale === "es-UY" && this.priceToFormat !== " ") {
      return this.priceToFormat;
    }
    return this.recommendation.price.displayValue;
  }
}
